import type { SearchDidYouMeanKind } from '~/utils/solr/spellcheck-suggestion'
import { truncateForJsonByteBudget } from './payload-size'

interface DidYouMeanPayloadInput {
  searchId: string
  sourceQuery: string
  suggestedQuery: string
  didYouMeanKind: SearchDidYouMeanKind
  hasResults: boolean
  page: number
  hasFilters: boolean
}

export function buildSearchDidYouMeanShownPayload(input: DidYouMeanPayloadInput) {
  return {
    searchId: input.searchId,
    sourceQuery: truncateForJsonByteBudget(input.sourceQuery, 120, 120),
    suggestedQuery: truncateForJsonByteBudget(input.suggestedQuery, 120, 120),
    didYouMeanKind: input.didYouMeanKind,
    hasResults: input.hasResults,
    page: input.page,
    hasFilters: input.hasFilters,
  }
}

export function buildSearchDidYouMeanSelectedPayload(
  impression: ReturnType<typeof buildSearchDidYouMeanShownPayload>,
) {
  const { hasResults: _hasResults, ...selected } = impression
  return selected
}
